<section class="sc-hero">

  <div class="container">

    <div class="row align-items-center">

      <div class="col-12 col-lg-6">

        <div class="row">

          <div class="col-12 col-lg-12">
            <h1 class="heading-xl">Innovationen im Recruiting <br> seit 10 Jahren</h1>
          </div>

          <div class="col-12 col-md-10 col-lg-12 offset-lg-0">
            <p class="larger">
              Alles, was wir tun, zielt darauf ab, gute Beziehungen zu schaffen. Für unsere Kandidat:innen und Kund:innen genauso, wie für unser Team. Dabei entwicklen wir als Technologieführer im Active Sourcing neue Systeme und Lösungen, die Innovationen schaffen: Vom ersten Jobsite-Chatbot im Jahr 2014 bis zur eigenen Sourcing-KI zehn Jahre später.
            </p>
          </div>

        </div>

      </div>

      <div class="col-12 col-sm-10 col-md-7 offset-md-2 col-lg-5 offset-lg-1 mt-6 mt-lg-0">
        <img src="assets/img/sc-unternehmen-header.jpg" width="500" height="683" class="img-fluid">
      </div>

    </div>

  </div>

</section>
